import React, { useEffect, useState } from "react";
import "../../Main.css";
import { Box, Grid, useMediaQuery } from "@mui/material";
import Chat from "../chat/Chat";
import {
  getSavingVariables,
  getSavingVariablesFil,
} from "../../../../utils/firestoreQuery";
import BG from "../../../../assets/flowing-cape.gif";
import { useSelector } from "react-redux";

function End() {
  const [objData, setObjData] = useState();
  const lang = useSelector((state) => state.chat.language);
  const md = useMediaQuery("(min-width:900px)", { noSsr: true });
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (lang === "ENG") {
          const documentSnapshot = await getSavingVariables().get();
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();

            setObjData(data);
          } else {
            console.log("Document does not exist");
          }
        } else if (lang === "FIL") {
          const documentSnapshot = await getSavingVariablesFil().get();
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();

            setObjData(data);
          } else {
            console.log("Document does not exist");
          }
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    fetchData();
  }, [lang]);

  return (
    <>
      <Box
        sx={
          {
            //   backgroundImage: `url(${BG})`,
            //   backgroundSize: "100% 100%",
            //   minHeight: "102.2vh",
          }
        }
      >
        <Grid item xs={12}>
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img
              src={BG}
              style={{
                display: "block",
                width: "100%",
                height: md ? "100vh" : "auto",
                objectFit: "fill",
              }}
              alt="image"
            />
            <Box
              sx={{
                position: md ? "absolute" : "absolute",
                top: md ? "0%" : "14%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: md ? "center" : "left",
                flexDirection: "column",
                paddingTop: "5%",
                paddingLeft: "1rem",
                color: "white",
              }}
            >
              <h1>Congrats!</h1>
              <p style={{ marginTop: "1rem", fontSize: "1.5rem" }}>
                {lang === "ENG" && "You just finished this learning tool."}
                {lang === "FIL" && "Natapos mo na ang learning tool na ito."}
              </p>
            </Box>

            <Box
              style={{
                position: md ? "absolute" : "inherit",
                width: "100%",
                height: "100%",
                paddingTop: "1rem",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#FFFFFF40",
                  height: md ? "60%" : "80%",
                  padding: "1.5rem",
                  borderRadius: "1rem",
                  width: md ? "60%" : "70%",
                  marginLeft: md ? "2%" : "15%",

                  marginBottom: "1rem",
                  marginTop: md ? "10rem" : "1rem",
                }}
              >
                {objData && (
                  <Chat
                    pageLang={lang}
                    objData={objData.zClosing}
                    mainContainer={{
                      height: md ? "inherit" : "400px",
                      flexGrow: "1",
                    }}
                  />
                )}
              </Box>
            </Box>
          </div>
        </Grid>
      </Box>
    </>
  );
}

export default End;
